import httpClient from '@/api/httpClient'

/**
 * UU数固定モード用
 */
export class SimulationMock {
  static async getSimulation(simulationPlan) {
    try {
      const res = await httpClient.post('/simulation/mock', simulationPlan)
      return res.data
    } catch (e) {
      console.error(e)
      throw e
    }
  }
}
